/**
 * SOFT-LOCK MARKER — the small soft-glow orb that floats above the locked target (user call
 * 2026-07-21: a glowy sphere overhead, not a ground ring). A camera-facing sprite with a
 * baked radial-gradient glow: additive, no depth write, so it reads as light, not geometry.
 * Shared by main.ts and the combat lab (rendering stays with the renderers; combat/softLock.ts
 * stays pure selection).
 */
import * as THREE from "three";

/** How far above the target's anchor position the orb floats (m) — clear of a humanoid head. */
export const LOCK_MARKER_LIFT = 2.5;

export function makeLockMarker(): THREE.Sprite {
  const c = document.createElement("canvas");
  c.width = c.height = 64;
  const g = c.getContext("2d")!;
  const grad = g.createRadialGradient(32, 32, 0, 32, 32, 32);
  grad.addColorStop(0, "rgba(255, 240, 205, 1)"); // hot core
  grad.addColorStop(0.22, "rgba(255, 200, 96, 0.9)"); // the lock gold
  grad.addColorStop(0.55, "rgba(255, 180, 64, 0.22)"); // soft falloff
  grad.addColorStop(1, "rgba(255, 180, 64, 0)");
  g.fillStyle = grad;
  g.fillRect(0, 0, 64, 64);
  const sprite = new THREE.Sprite(
    new THREE.SpriteMaterial({
      map: new THREE.CanvasTexture(c),
      blending: THREE.AdditiveBlending,
      depthWrite: false,
      transparent: true,
    }),
  );
  sprite.scale.setScalar(0.55);
  sprite.name = "lockMarker"; // probe seam: the scene root holds other additive sprites (stars)
  return sprite;
}
